module.exports = __webpack_public_path__ + "static/img/dyson-logo.b73c3664.jpg";